function Contact() {
  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="contact-panel">
          <div className="contact-copy">
            <span className="eyebrow eyebrow-light">Let’s learn together</span>
            <h2>Give your child a brighter way to learn.</h2>
            <p>
              Speak with our team about the right program, class schedule and a
              complimentary trial session.
            </p>
            <a
              className="btn btn-accent"
              href="https://wa.me/919242912480?text=Hi%20I'm%20interested%20in%20your%20courses!"
              target="_blank"
              rel="noopener noreferrer"
            >
              Chat on WhatsApp <span aria-hidden="true">→</span>
            </a>
          </div>

          <div className="contact-cards">
            <a href="mailto:info@thebrightfutureabacus.com" className="contact-card">
              <span className="contact-icon" aria-hidden="true">✉</span>
              <span><small>Email us</small><strong>info@thebrightfutureabacus.com</strong></span>
            </a>
            <div className="contact-card">
              <span className="contact-icon" aria-hidden="true">⌖</span>
              <span><small>Visit us</small><strong>Bachupally, Hyderabad 500090</strong></span>
            </div>
            <div className="contact-card">
              <span className="contact-icon" aria-hidden="true">◷</span>
              <span><small>Class format</small><strong>Flexible live online sessions</strong></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
